export const privacyFr = {
  privacy: {
    page_title: "Politique de Confidentialité",
    title: "Politique de Confidentialité",
    last_updated: "Dernière mise à jour",

    introduction: {
      title: "Introduction",
      content: "ID Network ('nous', 'notre' ou 'nos') s'engage à protéger votre vie privée. Cette Politique de Confidentialité explique comment nous collectons, utilisons, divulguons et protégeons vos informations lorsque vous utilisez notre plateforme de réservation et de gestion de studios. Cette politique est conforme au Règlement Général sur la Protection des Données (RGPD) de l'UE et aux autres lois applicables en matière de protection des données."
    },

    data_controller: {
      title: "Responsable du Traitement des Données",
      content: "Le responsable du traitement de vos données personnelles est :",
      company_name: "Société",
      email: "Email"
    },

    data_collection: {
      title: "Informations que Nous Collectons",
      intro: "Nous collectons les types d'informations suivants :",
      personal_info: "Informations d'identification personnelle (nom, adresse e-mail, numéro de téléphone)",
      contact_info: "Coordonnées de votre studio ou entreprise",
      business_info: "Informations commerciales (nom du studio, adresse, services proposés)",
      booking_info: "Données de réservation et de calendrier",
      usage_data: "Données d'utilisation et analytiques"
    },

    data_purpose: {
      title: "Finalité du Traitement des Données",
      intro: "Nous utilisons vos données aux fins suivantes :",
      service_provision: "Fournir et maintenir notre service de gestion des réservations",
      booking_management: "Gérer les réservations, rendez-vous et plannings",
      calendar_sync: "Synchroniser avec Google Agenda (avec votre consentement explicite)",
      communication: "Communiquer avec vous concernant vos réservations et votre compte",
      analytics: "Améliorer nos services grâce aux analyses",
      legal_compliance: "Respecter les obligations légales"
    },

    google_calendar: {
      title: "Intégration Google Agenda",
      content: "Si vous choisissez de connecter votre Google Agenda, nous allons :",
      read_events: "Lire vos événements de calendrier pour éviter les doubles réservations",
      write_events: "Créer et mettre à jour les événements de calendrier pour les réservations confirmées",
      sync_status: "Synchroniser les changements de statut des réservations avec votre calendrier",
      user_control: "Vous pouvez révoquer l'accès au calendrier à tout moment via les paramètres de votre compte ou les autorisations de votre compte Google. Nous n'accédons qu'aux données de calendrier nécessaires à la gestion des réservations et ne partageons jamais vos informations de calendrier avec des tiers."
    },

    legal_basis: {
      title: "Base Légale du Traitement (RGPD)",
      consent: {
        title: "Consentement",
        content: "Pour l'intégration de Google Agenda et les communications marketing"
      },
      contract: {
        title: "Exécution du Contrat",
        content: "Pour fournir les services de gestion des réservations"
      },
      legitimate: {
        title: "Intérêts Légitimes",
        content: "Pour l'amélioration du service et les analyses"
      }
    },

    data_sharing: {
      title: "Partage et Divulgation des Données",
      intro: "Nous ne vendons pas vos données personnelles. Nous pouvons partager vos informations avec :",
      service_providers: "Les prestataires de services qui nous aident à exploiter notre plateforme (hébergement, analyses)",
      google: "Google (uniquement pour la synchronisation du calendrier, avec votre consentement)",
      legal_requirements: "Les autorités légales lorsque requis par la loi"
    },

    data_retention: {
      title: "Conservation des Données",
      content: "Nous conservons vos données personnelles uniquement aussi longtemps que nécessaire pour remplir les finalités décrites dans cette politique, sauf si une période de conservation plus longue est requise par la loi. L'historique des réservations est conservé pendant 3 ans pour les registres commerciaux. Vous pouvez demander la suppression de votre compte et de vos données à tout moment."
    },

    user_rights: {
      title: "Vos Droits en Vertu du RGPD",
      intro: "Vous disposez des droits suivants concernant vos données personnelles :",
      access: {
        title: "Droit d'Accès",
        content: "Demander une copie de vos données personnelles"
      },
      rectification: {
        title: "Droit de Rectification",
        content: "Corriger les données inexactes ou incomplètes"
      },
      erasure: {
        title: "Droit à l'Effacement",
        content: "Demander la suppression de vos données personnelles"
      },
      restriction: {
        title: "Droit à la Limitation",
        content: "Limiter le traitement de vos données"
      },
      portability: {
        title: "Droit à la Portabilité",
        content: "Recevoir vos données dans un format structuré"
      },
      objection: {
        title: "Droit d'Opposition",
        content: "S'opposer au traitement fondé sur des intérêts légitimes"
      },
      withdraw: {
        title: "Droit de Retirer le Consentement",
        content: "Retirer votre consentement au traitement des données à tout moment"
      },
      contact: "Pour exercer ces droits, veuillez nous contacter à"
    },

    data_security: {
      title: "Sécurité des Données",
      content: "Nous mettons en œuvre des mesures de sécurité techniques et organisationnelles appropriées pour protéger vos données personnelles contre l'accès non autorisé, la modification, la divulgation ou la destruction. Cela inclut le chiffrement, des serveurs sécurisés et des évaluations de sécurité régulières."
    },

    cookies: {
      title: "Cookies et Suivi",
      content: "Nous utilisons des cookies essentiels pour maintenir votre session et vos préférences. Nous utilisons des cookies analytiques pour comprendre comment vous utilisez notre service. Vous pouvez contrôler les préférences des cookies via les paramètres de votre navigateur."
    },

    international_transfers: {
      title: "Transferts Internationaux de Données",
      content: "Vos données sont principalement stockées au sein de l'Union européenne. Si des données sont transférées en dehors de l'UE, nous veillons à ce que des garanties appropriées soient en place, telles que les Clauses Contractuelles Types approuvées par la Commission européenne."
    },

    children: {
      title: "Confidentialité des Enfants",
      content: "Notre service n'est pas destiné aux personnes de moins de 16 ans. Nous ne collectons pas sciemment de données personnelles auprès d'enfants."
    },

    changes: {
      title: "Modifications de cette Politique de Confidentialité",
      content: "Nous pouvons mettre à jour cette Politique de Confidentialité de temps en temps. Nous vous informerons des modifications importantes en publiant la nouvelle politique sur cette page et en mettant à jour la date de 'Dernière mise à jour'."
    },

    contact: {
      title: "Nous Contacter",
      content: "Si vous avez des questions concernant cette Politique de Confidentialité ou souhaitez exercer vos droits, veuillez nous contacter :"
    },

    supervisory: {
      title: "Autorité de Contrôle",
      content: "Vous avez le droit de déposer une plainte auprès d'une autorité de contrôle, en particulier dans l'État membre de l'UE de votre résidence, si vous estimez que notre traitement de vos données personnelles viole le RGPD."
    }
  }
};
